import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Password from "./password";
import Prefectures from "./prefectures";
import Submit from "./submit";
import InterestBrands from "./interestBrands";
import Newsletter from "./newsletter";
import Tooltip from "~/js/common/tooltip";

export default class Register {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    this.header = new Header();
    this.footer = new Footer();
    this.tooltip = new Tooltip();

    this.passwords = [];
    const _password = document.querySelectorAll(".f-password");
    for (var i = 0; i < _password.length; i++) {
      this.passwords.push(new Password(_password[i]));
    }
    if (document.querySelector(".f-country") && document.querySelector(".f-postcode") && document.querySelector(".f-prefectures")) {
      this.prefectures = new Prefectures(document.querySelector(".f-country"), document.querySelector(".f-postcode"), document.querySelector(".f-prefectures"));
    }
    if (document.querySelector(".f-checkbox1") && document.querySelector(".f-checkbox2") && document.querySelector(".f-submit")) {
      this.submit = new Submit(document.querySelector(".f-checkbox1"), document.querySelector(".f-checkbox2"), document.querySelector(".f-submit"));
    }
    if (document.querySelector(".f-interestBrands")) {
      this.interestBrands = new InterestBrands(document.querySelector(".f-interestBrands"));
    }
    if (document.querySelector(".f-newsletter")) {
      this.newsletter = new Newsletter(document.querySelector(".f-newsletter"));
    }

    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Register();
});
